export const appleAppId = process.env.NEXT_PUBLIC_APPLE_APP_ID || '';
export const facebookAppId = process.env.NEXT_PUBLIC_FACEBOOK_APP_ID || '';
export const googleAppId = process.env.NEXT_PUBLIC_GOOGLE_APP_ID || '';
export const appleRedirectUri = process.env.NEXT_PUBLIC_APPLE_REDIRECT_URI || '';
